import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const Regulation40OfLodr = () => {
  const pageid = 11; // <-- set your correct pageid for this section
  const [regulations, setRegulations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRegulations = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setRegulations([]);
          return;
        }

        // Map API response into label + file structure
        const formatted = result.data.map((item) => ({
          label: item.pdf_name,
          file: item.upload_file_path,
        }));

        setRegulations(formatted);
      } catch (error) {
        console.error("Fetch failed:", error);
        setRegulations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRegulations();
  }, []);

  return (
    <>
      <Helmet>
        <title>Regulation 40 Of LODR | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investorregulations40oflodr.png"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
              Regulation 40 of LODR
            </h1>
          </div>
        </div>
      </div>

      {/* PDF Section */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p>Loading certificates...</p>
        ) : regulations.length === 0 ? (
          <p>No certificates found.</p>
        ) : (
          <ul className="list-disc pl-6 space-y-2 text-[#0b3a6a]">
            {regulations.map((item, idx) => (
              <li key={idx}>
                <a
                  href={item.file ? `${API_PDF_URL}/${item.file}` : "#"} // ✅ Use # if no PDF
                  target={item.file ? "_blank" : "_self"} // ✅ Open in new tab only if PDF exists
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>

      <Footer />
    </>
  );
};

export default Regulation40OfLodr;
